import * as React from 'react';
export function useMergedRef(...refs) {
    return React.useCallback((element) => {
        for (let i = 0; i < refs.length; i++) {
            const ref = refs[i];
            if (typeof ref === 'function')
                ref(element);
            else if (ref && typeof ref === 'object')
                ref.current = element;
        }
    }, refs);
}
//# sourceMappingURL=useMergedRef.js.map